import { CustomersStepTypeEnum } from "@/shared/endpoints/customers";

export const getDefaultOnboarding = (phoneNumber: string) => {
    return {
        details: {
            phoneNumber: phoneNumber.replaceAll('-', ''),
            currentStep: CustomersStepTypeEnum.AboutYou,
            visitedAboutYou: false,
            visitedInsurance: false,
            visitedMyMedbox: false
        }
    };
};
